<template>
  <div class="container-fluid tiendas-page">
    <Breadcrumbs title="Tiendas" />

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="row g-3 align-items-end">
              <div class="col-lg-3 col-md-6 col-12">
                <label for="filtroFormato" class="form-label">Formato</label>
                <select
                  id="filtroFormato"
                  class="form-select"
                  v-model="filtroFormato"
                >
                  <option value="">Todos</option>
                  <option
                    v-for="formato in formatosDisponibles"
                    :key="formato.value"
                    :value="formato.value"
                  >
                    {{ formato.label }}
                  </option>
                </select>
              </div>

              <div class="col-lg-3 col-md-6 col-12">
                <label for="filtroNombre" class="form-label">Nombre de sucursal</label>
                <input
                  id="filtroNombre"
                  type="text"
                  class="form-control"
                  placeholder="Buscar por nombre"
                  v-model.trim="filtroNombre"
                />
              </div>

              <div class="col-lg-3 col-md-6 col-12">
                <label for="filtroDivision" class="form-label">Número de división</label>
                <input
                  id="filtroDivision"
                  type="text"
                  class="form-control"
                  placeholder="Ej: 7104"
                  v-model.trim="filtroDivision"
                />
              </div>

              <div class="col-lg-3 col-md-6 col-12 text-lg-end">
                <button
                  class="btn btn-outline-secondary me-2 w-100 w-lg-auto mb-2 mb-lg-0"
                  type="button"
                  :disabled="estaCargando"
                  @click="recargarTiendas"
                >
                  <span v-if="estaCargando" class="spinner-border spinner-border-sm me-1" role="status" />
                  Recargar
                </button>
                <button
                  class="btn btn-primary w-100 w-lg-auto"
                  type="button"
                  @click="abrirModalCrear"
                >
                  Nueva tienda
                </button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div
              v-if="estaCargando && !tiendasFiltradas.length"
              class="text-center text-muted py-4"
            >
              <div class="spinner-border text-primary mb-3" role="status" />
              <p>Cargando tiendas...</p>
            </div>

            <TablaLista
              v-if="tiendasFiltradas.length"
              :data="tiendasFiltradas"
              :headers="headersTabla"
              :campos="camposTabla"
              :acciones="accionesTabla"
              :search="false"
              :elementosPagina="25"
              @realizarAccion="manejarAccionTabla"
            />

            <div
              v-if="!estaCargando && !tiendasFiltradas.length"
              class="text-center text-muted py-4"
            >
              <p>No se encontraron tiendas con los filtros seleccionados.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade show"
      tabindex="-1"
      style="display: block"
      v-if="mostrarModal"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ esModoEdicion ? "Editar tienda" : "Crear tienda" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="cerrarModal"
            />
          </div>
          <form @submit.prevent="guardarTienda">
            <div class="modal-body">
              <div class="row g-3">
                <div class="col-md-6 col-12">
                  <label for="tiendaNombre" class="form-label">Nombre de sucursal</label>
                  <input
                    id="tiendaNombre"
                    type="text"
                    class="form-control"
                    v-model.trim="formulario.nombre"
                    required
                  />
                </div>

                <div class="col-md-6 col-12">
                  <label for="tiendaDivision" class="form-label">Número de división</label>
                  <input
                    id="tiendaDivision"
                    type="number"
                    class="form-control"
                    v-model.number="formulario.division"
                    min="1"
                    required
                  />
                </div>

                <div class="col-md-6 col-12">
                  <label for="tiendaFormato" class="form-label">Formato</label>
                  <select
                    id="tiendaFormato"
                    class="form-select"
                    v-model="formulario.formato"
                    @change="onCambioFormato"
                    required
                  >
                    <option value="" disabled>Selecciona un formato</option>
                    <option
                      v-for="formato in formatosDisponibles"
                      :key="`form-${formato.value}`"
                      :value="formato.value"
                    >
                      {{ formato.label }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6 col-12" v-if="mostrarSelectorCategoria">
                  <label for="tiendaCategoria" class="form-label">Categoría</label>
                  <select
                    id="tiendaCategoria"
                    class="form-select"
                    v-model="formulario.categoria"
                  >
                    <option value="">General</option>
                    <option
                      v-for="categoria in categoriasSuperKompras"
                      :key="`cat-${categoria.value}`"
                      :value="categoria.value"
                    >
                      {{ categoria.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="cerrarModal"
                :disabled="accionEnProgreso"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="accionEnProgreso"
              >
                <span
                  v-if="accionEnProgreso"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                {{ esModoEdicion ? "Guardar cambios" : "Crear tienda" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show" v-if="mostrarModal" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
import TablaLista from "@/components/tablaLista.vue";

const CATEGORIAS_SUPER_KOMPRAS = [
  { value: "sk", label: "SK" },
  { value: "sk-micro", label: "SK Micro" },
];

export default {
  name: "ConfiguracionTiendas",
  components: {
    TablaLista,
  },
  data() {
    return {
      filtroFormato: "",
      filtroNombre: "",
      filtroDivision: "",
      headersTabla: [
        "Nombre",
        "División",
        "Formato",
        "Categoría",
        "Última actualización",
        "Acciones",
      ],
      camposTabla: [
        { tipo: "texto", clave: "nombre", bold: true },
        { tipo: "texto", clave: "division" },
        { tipo: "texto", clave: "formatoLabel" },
        { tipo: "texto", clave: "categoriaLabel" },
        { tipo: "texto", clave: "actualizadoEnTexto" },
        { tipo: "acciones", clave: "acciones" },
      ],
      accionesTabla: [
        { nombre: "Editar", color: "#172554", funcion: "editar" },
        { nombre: "Eliminar", color: "#900C3F", funcion: "eliminar" },
      ],
      mostrarModal: false,
      modoFormulario: "crear",
      formulario: {
        nombre: "",
        division: "",
        formato: "",
        categoria: "",
      },
      tiendaSeleccionada: null,
      accionEnProgreso: false,
    };
  },
  computed: {
    ...mapState("tiendas", {
      tiendasState: (state) => state.tiendas,
      cargandoTiendas: (state) => state.cargando,
    }),
    ...mapGetters("tiendas", {
      formatosDesdeStore: "formatosTiendas",
    }),
    formatosDisponibles() {
      return this.formatosDesdeStore || [];
    },
    estaCargando() {
      return this.cargandoTiendas || this.accionEnProgreso;
    },
    esModoEdicion() {
      return this.modoFormulario === "editar" && !!this.tiendaSeleccionada;
    },
    categoriasSuperKompras() {
      return CATEGORIAS_SUPER_KOMPRAS;
    },
    mostrarSelectorCategoria() {
      return this.formulario.formato === "super-kompras";
    },
    tiendasNormalizadas() {
      return this.tiendasState.map((tienda) => ({
        ...tienda,
        nombre: tienda.nombre,
        division: tienda.division ?? "-",
        formatoLabel: this.obtenerEtiquetaFormato(tienda.formato),
        categoriaLabel: this.obtenerEtiquetaCategoria(tienda.categoria),
        actualizadoEnTexto: tienda.actualizadoEn
          ? moment(tienda.actualizadoEn).format("DD/MM/YYYY HH:mm")
          : "N/D",
        raw: tienda,
      }));
    },
    tiendasFiltradas() {
      let resultado = [...this.tiendasNormalizadas];

      if (this.filtroFormato) {
        resultado = resultado.filter(
          (tienda) => tienda.raw.formato === this.filtroFormato
        );
      }

      if (this.filtroNombre) {
        const nombre = this.filtroNombre.toLowerCase();
        resultado = resultado.filter((tienda) =>
          tienda.nombre.toLowerCase().includes(nombre)
        );
      }

      if (this.filtroDivision) {
        const divisionFiltro = this.filtroDivision.toString();
        resultado = resultado.filter((tienda) =>
          String(tienda.division).includes(divisionFiltro)
        );
      }

      return resultado;
    },
  },
  created() {
    this.iniciarSuscripcion();
    this.recargarTiendas();
  },
  beforeUnmount() {
    this.detenerSuscripcion();
    document.body.classList.remove("modal-open");
  },
  watch: {
    mostrarModal(nuevoValor) {
      if (nuevoValor) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
  },
  methods: {
    ...mapActions("tiendas", [
      "iniciarSuscripcion",
      "detenerSuscripcion",
      "recargarTiendas",
      "crearTienda",
      "actualizarTienda",
      "eliminarTienda",
    ]),
    obtenerEtiquetaFormato(valor) {
      const formato = this.formatosDisponibles.find(
        (item) => item.value === valor
      );
      return formato ? formato.label : valor || "-";
    },
    obtenerEtiquetaCategoria(valor) {
      if (!valor) {
        return "-";
      }
      const categoria = this.categoriasSuperKompras.find(
        (item) => item.value === valor
      );
      return categoria ? categoria.label : valor;
    },
    manejarAccionTabla({ funcion, data }) {
      const tienda = data?.raw || data;
      if (!tienda) {
        return;
      }

      if (funcion === "editar") {
        this.abrirModalEditar(tienda);
      } else if (funcion === "eliminar") {
        this.confirmarEliminacion(tienda);
      }
    },
    abrirModalCrear() {
      this.modoFormulario = "crear";
      this.tiendaSeleccionada = null;
      this.formulario = {
        nombre: "",
        division: "",
        formato: "",
        categoria: "",
      };
      this.mostrarModal = true;
    },
    abrirModalEditar(tienda) {
      this.modoFormulario = "editar";
      this.tiendaSeleccionada = tienda;
      this.formulario = {
        nombre: tienda.nombre || "",
        division: tienda.division || "",
        formato: tienda.formato || "",
        categoria: tienda.categoria || "",
      };
      this.mostrarModal = true;
    },
    cerrarModal() {
      if (this.accionEnProgreso) {
        return;
      }
      this.mostrarModal = false;
    },
    onCambioFormato() {
      if (this.formulario.formato !== "super-kompras") {
        this.formulario.categoria = "";
      }
    },
    validarFormulario() {
      const errores = [];

      if (!this.formulario.nombre) {
        errores.push("El nombre de la sucursal es obligatorio.");
      }

      if (!this.formulario.division) {
        errores.push("El número de división es obligatorio.");
      }

      if (!this.formulario.formato) {
        errores.push("Selecciona un formato.");
      }

      return errores;
    },
    async guardarTienda() {
      const errores = this.validarFormulario();
      if (errores.length) {
        this.$swal({
          icon: "warning",
          title: "Formulario incompleto",
          text: errores.join(" "),
        });
        return;
      }

      this.accionEnProgreso = true;
      const payload = {
        nombre: this.formulario.nombre,
        division: this.formulario.division,
        formato: this.formulario.formato,
        categoria: this.formulario.categoria || null,
      };

      try {
        if (this.esModoEdicion) {
          await this.actualizarTienda({
            id: this.tiendaSeleccionada.id,
            datos: payload,
          });
          this.$swal({
            icon: "success",
            title: "Tienda actualizada",
            text: "Los cambios se guardaron correctamente.",
          });
        } else {
          await this.crearTienda(payload);
          this.$swal({
            icon: "success",
            title: "Tienda creada",
            text: "La tienda se registró correctamente.",
          });
        }
        this.cerrarModal();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error",
          text:
            error?.msg ||
            error?.message ||
            "No fue posible completar la acción.",
        });
      } finally {
        this.accionEnProgreso = false;
      }
    },
    async confirmarEliminacion(tienda) {
      const resultado = await this.$swal({
        title: "¿Eliminar tienda?",
        text: `Esta acción eliminará la sucursal "${tienda.nombre}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#900C3F",
      });

      if (resultado.isConfirmed) {
        try {
          this.accionEnProgreso = true;
          await this.eliminarTienda(tienda.id);
          this.$swal({
            icon: "success",
            title: "Tienda eliminada",
            text: "La tienda se eliminó correctamente.",
          });
        } catch (error) {
          this.$swal({
            icon: "error",
            title: "No se pudo eliminar",
            text:
              error?.msg ||
              error?.message ||
              "Intenta nuevamente más tarde.",
          });
        } finally {
          this.accionEnProgreso = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.modal-open {
  overflow: hidden;
}
.modal-backdrop {
  z-index: 1040;
}
.modal {
  z-index: 1050;
}
.tiendas-page .card-header label {
  font-weight: 600;
}
</style>

